/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7.99976 9.99999L10.9998 8L12.9998 9.99999L15.9999 8.00001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 2H21M3 2V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03968 16 7.15979 16 9.4 16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V2M3 2H1.5M21 2H22.5M12 16V19M12 19L7 22M12 19L17 22M12 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M3 2H21V9.6C21 11.8402 21 12.9603 20.564 13.816C20.1805 14.5686 19.5686 15.1805 18.816 15.564C17.9603 16 16.8402 16 14.6 16H9.4C7.15979 16 6.03969 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V2Z"
				fill="currentColor"
			/>
			<path
				d="M3 2H21M3 2V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03968 16 7.15979 16 9.4 16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V2M3 2H1.5M21 2H22.5M12 16V19M12 19L7 22M12 19L17 22M12 19V22M7.99976 9.99999L10.9998 8L12.9998 9.99999L15.9999 8.00001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 1.25C1.58579 1.25 1.25 1.58579 1.25 2C1.25 2.41421 1.58579 2.75 2 2.75H3V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03969 16 7.15979 16 9.4 16H11.25V18.5754L6.61413 21.3569C6.25894 21.57 6.14377 22.0307 6.35688 22.3859C6.56999 22.7411 7.03069 22.8562 7.38587 22.6431L11.25 20.3246V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V20.3246L16.6141 22.6431C16.9693 22.8562 17.43 22.7411 17.6431 22.3859C17.8562 22.0307 17.7411 21.57 17.3859 21.3569L12.75 18.5754V16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V2.75H22C22.4142 2.75 22.75 2.41421 22.75 2C22.75 1.58579 22.4142 1.25 22 1.25H2ZM16.6239 7.584C16.8537 7.92865 16.7605 8.3943 16.4159 8.62405L13.4158 10.624C13.1183 10.8223 12.7222 10.7831 12.4694 10.5303L10.9042 8.9651L8.41578 10.624C8.07113 10.8538 7.60548 10.7607 7.37571 10.416C7.14595 10.0714 7.23909 9.60571 7.58374 9.37595L10.5838 7.37596C10.8812 7.17765 11.2773 7.21687 11.5301 7.46967L13.0953 9.0349L15.5839 7.37596C15.9285 7.14621 16.3942 7.23935 16.6239 7.584Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 2H21H22.5M3 2V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03968 16 7.15979 16 9.4 16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V5.5M3 2H1.5M12 16V19M12 19L7 22M12 19L17 22M12 19V22M7.99976 9.99999L10.9998 8L12.9998 9.99999L15.9999 8.00001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 2H21M3 2V9.6C3 11.8402 3 12.9603 3.43597 13.816C3.81947 14.5686 4.43139 15.1805 5.18404 15.564C6.03968 16 7.15979 16 9.4 16H14.6C16.8402 16 17.9603 16 18.816 15.564C19.5686 15.1805 20.1805 14.5686 20.564 13.816C21 12.9603 21 11.8402 21 9.6V2M3 2H1.5M21 2H22.5M12 16V19M12 19L7 22M12 19L17 22M12 19V22M7.99976 9.99999L10.9998 8L12.9998 9.99999L15.9999 8.00001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3 2H21V9.6C21 11.8402 21 12.9603 20.564 13.816C20.1805 14.5686 19.5686 15.1805 18.816 15.564C17.9603 16 16.8402 16 14.6 16H9.4C7.15979 16 6.03969 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V2Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 2C1.25 1.58579 1.58579 1.25 2 1.25H22C22.4142 1.25 22.75 1.58579 22.75 2C22.75 2.41421 22.4142 2.75 22 2.75H2C1.58579 2.75 1.25 2.41421 1.25 2ZM16.6239 7.584C16.8537 7.92865 16.7605 8.3943 16.4159 8.62405L13.4158 10.624C13.1183 10.8223 12.7222 10.7831 12.4694 10.5303L10.9042 8.96509L8.41578 10.624C8.07113 10.8538 7.60548 10.7607 7.37571 10.416C7.14595 10.0714 7.23909 9.60571 7.58374 9.37595L10.5838 7.37596C10.8812 7.17765 11.2773 7.21687 11.5301 7.46967L13.0953 9.0349L15.5839 7.37596C15.9285 7.14621 16.3942 7.23935 16.6239 7.584ZM12 15.25C12.4142 15.25 12.75 15.5858 12.75 16V18.5754L17.3859 21.3569C17.7411 21.57 17.8562 22.0307 17.6431 22.3859C17.43 22.7411 16.9693 22.8562 16.6141 22.6431L12.75 20.3246V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20.3246L7.38587 22.6431C7.03069 22.8562 6.56999 22.7411 6.35688 22.3859C6.14377 22.0307 6.25894 21.57 6.61413 21.3569L11.25 18.5754V16C11.25 15.5858 11.5858 15.25 12 15.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
